import React from 'react';
import { faLocation } from '@fortawesome/pro-solid-svg-icons/faLocation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Stack, styled } from 'bumbag';
import type { ReactElement } from 'react';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import Geolocation from 'react-geolocation';
const LargeButton = styled(Button)`
  width: 100%;
`;
type Props = {
  children: ReactElement | ((...args: Array<any>) => any);
  onSkipHealthFund?: (...args: Array<any>) => any;
  enabled: boolean;
  locationPermissionsRequestedRenderer: (...args: Array<any>) => any;
  locationPermissionsRejectedRenderer: (...args: Array<any>) => any;
  onSuccess?: (...args: Array<any>) => any;
  wrapper?: (...args: Array<any>) => any;
};
type State = {
  error: Record<string, any> | null | undefined;
  isRejected: boolean;
};
export default class WithRequestLocationPermissions extends React.Component<Props, State> {
  static defaultProps = {
    onSkipHealthFund: null,
    onSuccess: () => {},
    wrapper: (children: any) => children,
  };
  state = {
    error: null,
    isRejected: false,
  };
  handleClickTryAgain = () =>
    this.setState({
      isRejected: false,
    });
  handleError = (error: Record<string, any> | null | undefined) =>
    this.setState({
      error,
      isRejected: true,
    });
  render = () => {
    const {
      children,
      enabled,
      locationPermissionsRejectedRenderer,
      locationPermissionsRequestedRenderer,
      onSuccess,
      wrapper,
      onSkipHealthFund,
    } = this.props;
    const { error, isRejected } = this.state;
    return enabled ? (
      <Geolocation
        lazy
        timeout={15000}
        maximumAge={900}
        onSuccess={onSuccess}
        onError={this.handleError}
        // @ts-expect-error TS(7031): Binding element 'fetchingPosition' implicitly has ... Remove this comment to see the full error message
        render={({ fetchingPosition, getCurrentPosition, position }) =>
          position
            ? typeof children === 'function'
              ? children({
                  position,
                })
              : children
            : // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
              wrapper(
                <Stack spacing="major-3">
                  <Box textAlign="center">
                    <div className="flex flex-col items-center">
                      <FontAwesomeIcon icon={faLocation} className="mb-2 text-2xl text-primary-base antialiased" />
                      <p className="flex text-center text-2xl">Location needed</p>
                    </div>
                  </Box>
                  {isRejected
                    ? locationPermissionsRejectedRenderer({
                        error,
                      })
                    : locationPermissionsRequestedRenderer()}
                  {!isRejected && (
                    <Box textAlign="center">
                      <LargeButton palette="secondary" isLoading={fetchingPosition} onClick={getCurrentPosition}>
                        CONTINUE
                      </LargeButton>
                      <LargeButton
                        palette="secondary"
                        marginTop="major-1"
                        disabled={fetchingPosition}
                        variant="ghost"
                        onClick={() => this.handleError(null)}
                      >
                        I don{"'"}t want to share my location
                      </LargeButton>
                    </Box>
                  )}
                  {isRejected && (
                    <Box>
                      <LargeButton palette="secondary" onClick={this.handleClickTryAgain}>
                        Go back & try again
                      </LargeButton>
                      <LargeButton
                        palette="secondary"
                        marginTop="major-1"
                        disabled={fetchingPosition}
                        variant="ghost"
                        onClick={onSkipHealthFund}
                      >
                        Don{"'"}t share location, pay full amount
                      </LargeButton>
                    </Box>
                  )}
                </Stack>,
              )
        }
      />
    ) : typeof children === 'function' ? (
      children({
        position: null,
      })
    ) : (
      children
    );
  };
}
